export function getSubParts(number) {
    if (!number) return '';
    return `${number.toFixed(4)}`;
}
